import { m } from 'motion/react';

const Popup = ({ titleId, icon: Icon, tone = 'info', children }) => (
  <div className="overlay">
    <m.div className="pop" role="dialog" aria-modal="true" aria-labelledby={titleId}
      initial={{ opacity: 0, scale: 0.96 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.96 }}
      transition={{ duration: .22, ease: [.16, 1, .3, 1] }}
    >
      <div className="pop__body">
        {Icon && (
          <span className={`popmark popmark--${tone}`} aria-hidden="true">
            {typeof Icon === 'string' ? Icon : <Icon />}
          </span>
        )}
        {children}
      </div>
    </m.div>
  </div>
);

export default Popup;
